(function($) {
    var $supapressJQuery = jQuery.noConflict(),
        $wrap = $supapressJQuery('.supapress-wrap'),
        $form = $wrap.find('#supapress-add-edit-form'),
        $step1 = $wrap.find('#step1'),
        $step2 = $wrap.find('#step2'),
        $message = $wrap.find('#message'),
        $element = $wrap.find('.supapress-accordion-header'),
        $selector = $wrap.find('.elements.nav-tab-content .selector'),
        $step1NextButton = $wrap.find("#step1_next_btn"),
        $widgetTitleWrapper = $wrap.find(".widget-title-wrapper"),
        $widgetTypeWrapper = $wrap.find('.widget-type-wrapper'),
        $widgetTitle = $widgetTitleWrapper.find("#widget-title"),
        $widgetLayout = $wrap.find('input[name="widget_layout"]'),
        $subContentSwitch = $wrap.find('.sub-content-toggle'),
        $navTab = $wrap.find(".nav-tab"),
        $navTabContent = $wrap.find(".nav-tab-content"),
        $layoutContent = $wrap.find(".layout-content"),
        $isbnLookupSource = $wrap.find("#lookup_source"),
        $isbnLookupBulk = $wrap.find("#isbn_lookup_bulk"),
        $isbnLookupSourceInputs = $wrap.find(".lookup-source-input"),
        $saveButtonWrapper = $wrap.find('.save-button-wrapper'),
        fadeIn = true,
        fadeOut = true,
        typeParameter = '',
        step2positioning = function() {
            $widgetTypeWrapper.prependTo($step2);
            $widgetTitleWrapper.prependTo($step2).find('p').hide();

            $widgetTypeWrapper.find('input').on('change', function() {
                var $this = $(this),
                    $label = $widgetTypeWrapper.find('label[for="' + $this.attr('id') + '"]');

                $label.prependTo($label.parent());
                $this.prependTo($this.parent());

                // Set tabs
                setTabs($widgetTypeWrapper.find('input:checked').val());

                // Change tab content
                setNavContent($navTabContent, $supapressJQuery('.nav-tab-active').attr('data-tab'));

                // Change layout content
                setNavContent($layoutContent, $supapressJQuery('.widget-layout-wrapper').find('input:checked').attr('data-sub-tab'));
            });

            $widgetTypeWrapper.find('input').on('click', function() {
                if($widgetTypeWrapper.hasClass('open')) {
                    $widgetTypeWrapper.removeClass('open');
                } else {
                    $widgetTypeWrapper.addClass('open');
                }
            });

            $widgetTypeWrapper.find('input:checked').trigger('change');

            // Set tabs
            setTabs($widgetTypeWrapper.find('input:checked').val());

            // Change tab content
            setNavContent($navTabContent, $supapressJQuery('.nav-tab-active').attr('data-tab'));

            // Change layout content
            setNavContent($layoutContent, $supapressJQuery('.widget-layout-wrapper').find('input:checked').attr('data-sub-tab'));
        },
        setNavContent = function($container, selector) {
            // Loop content wrappers and show the one matching the click tabs data value
            $container.each(function() {
                var $this = $(this);

                // If the tab value is found show content
                if($this.hasClass(selector) && !$this.hasClass('sub-content-wrapper')) {
                    if(selector === 'elements') {
                        $selector.find('.supapress-field-wrapper').each(function() {
                            var $elem = $(this);

                            if(!$elem.hasClass('all-tabs') && !$elem.hasClass($widgetTypeWrapper.find('input:checked').val())) {
                                $elem.hide().find('input:checked').attr('checked', false);
                            } else {
                                $elem.show();
                            }
                        });
                    } else if(selector === 'arrangement') {
                        $this.find('.widget-layout-wrapper-inner').each(function() {
                            var $elem = $(this);

                            if($elem.hasClass($widgetTypeWrapper.find('input:checked').val())) {
                                $elem.show();
                            } else {
                                $elem.hide();
                            }
                        });
                    }

                    $this.show();
                } else {
                    $this.hide();
                }
            });

            // Hide elements not specific to widget type
            $('.widget-type-specific').each(function() {
                var $elem = $(this);

                if($elem.hasClass($widgetTypeWrapper.find('input:checked').val())) {
                    $elem.show();

                    if($elem.hasClass('custom_layout_file')) {
                        $elem.find('select').removeAttr('disabled');
                    }
                } else {
                    $elem.hide();

                    if($elem.hasClass('custom_layout_file')) {
                        $elem.find('select').attr('disabled', 'disabled');
                    }
                }
            });
            
            // Temporary hack to hide all carousel elements when the widget is not isbn_lookup
            if($widgetTypeWrapper.find('input:checked').val() !== 'isbn_lookup') {
                $wrap.find('.carousel.layout-content').hide();

                if($supapressJQuery('.widget-layout-wrapper').find('input:checked').val() === 'carousel') {
                    $wrap.find('#widget_layout1').trigger('click');
                }
            }

            // Turn fade in off as trigger comes from tab change
            fadeIn = false;
            // Turn fade out off when switching between module types
            fadeOut = false;

            // Trigger change to set on page load
            $subContentSwitch.trigger('change');

            // Turn fade out back on so it works when you click on/off element switches
            fadeOut = true;
        },
        setTabs = function(type) {
            if(type === 'product_details') {
                // show arrangement if there are custom templates
                if(!$wrap.find('.custom_layout_file.product_details').length) {
                    $wrap.find('.nav-tab[data-tab="content"], .nav-tab[data-tab="arrangement"]').removeClass('nav-tab-active').hide();
                    $widgetLayout.filter('[value="grid"]').prop('checked', true);
                } else {
                    $wrap.find('.nav-tab[data-tab="content"]').removeClass('nav-tab-active').hide();
                    $wrap.find('.nav-tab[data-tab="arrangement"]').removeClass('nav-tab-active').show();
                    $widgetLayout.filter('[value="custom"]').prop('checked', true);
                }
                $wrap.find('.nav-tab[data-tab="elements"]').addClass('nav-tab-active').show();
                $wrap.find('.nav-tab[data-tab="restrictions"]').hide();
            } else if(type === 'search_results') {
                $wrap.find('.nav-tab').removeClass('nav-tab-active').show();
                $wrap.find('.nav-tab[data-tab="content"], .nav-tab[data-tab="seo"]').hide();
                $wrap.find('.nav-tab[data-tab="restrictions"]').show();
                $wrap.find('.nav-tab[data-tab="elements"]').addClass('nav-tab-active');
            } else {
                $wrap.find('.nav-tab').removeClass('nav-tab-active').show();
                $wrap.find('.nav-tab[data-tab="seo"], .nav-tab[data-tab="restrictions"]').hide();
                $wrap.find('.nav-tab[data-tab="content"]').addClass('nav-tab-active');
            }
        },
        getUrlParameter = function getUrlParameter(sParam) {
            var sPageURL = decodeURIComponent(window.location.search.substring(1)),
                sURLVariables = sPageURL.split('&'),
                sParameterName,
                i;

            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split('=');

                if (sParameterName[0] === sParam) {
                    return sParameterName[1] === undefined ? '' : sParameterName[1];
                }
            }
        };

    // Add click events to navigation tabs
    $navTab.on('click', function() {
        var $navTabClicked = $(this),
            saveButtonWrapperHidden = $saveButtonWrapper.hasClass('hide');

        // Remove and add new active class
        $navTab.removeClass('nav-tab-active');
        $navTabClicked.addClass('nav-tab-active');

        // Change tab content
        setNavContent($navTabContent, $navTabClicked.attr('data-tab'));
    });

    // Add change event to layout selector
    $widgetLayout.on('change', function() {
        // Change tab content
        setNavContent($layoutContent, $(this).attr('data-sub-tab'));
    });

    // Trigger change to set on page load
    setNavContent($layoutContent, $('input[name="widget_layout"]:checked').attr('data-sub-tab'));

    // Add change event to lookup source to show / hide relevant inputs
    $isbnLookupSource.on('change', function() {
        $isbnLookupSourceInputs.each(function() {
            var $this = $(this);

            // If the lookup source value is found show input
            if($this.hasClass($isbnLookupSource.val())) {
                $this.show();
            } else {
                $this.hide();
            }
        });
    });

    // Trigger change to set on page load
    $isbnLookupSource.trigger('change');

    // Add click event to next button follow widget title and type selection
    $step1NextButton.on('click', function() {
        if($.trim($widgetTitle.val()) === '') {
            $message.addClass('warning').removeClass('hide');
            $message.find('p').text('Please enter a name for your widget');
        } else {
            $step1.hide();
            $step2.show();
            $message.addClass('hide');

            step2positioning();
        }
    });

    // On toggle switch show / hide attached sub content
    $subContentSwitch.on('change', function() {
        var $this = $(this),
            $content = $('div.' + $this.attr('data-sub-content'));

        if($this.prop('checked') && ($content.hasClass($('input[name="widget_layout"]:checked').attr('data-sub-tab')) || $content.hasClass('tab-level'))) {
            if($content.css('display') === 'none' && fadeIn) {
                $content.fadeIn();
            } else {
                $content.show();
            }
        } else {
            if($content.css('display') !== 'none' && fadeOut) {
                $content.fadeOut();
            } else {
                $content.hide();
            }
        }

        // Reset to fade in
        fadeIn = true;
    });

    // Show / Hide the config settings for the element
    $element.on('click', function() {
        var $this = $(this),
            $elementParent = $this.parents('.supapress-accordion-wrapper'),
            $elementArrow = $elementParent.find('.svg-right-arrow'),
            $elementConfig = $elementParent.find('.supapress-accordion-content');

        if($elementConfig.css('display') === 'none') {
            $elementConfig.slideDown();
            $elementArrow.addClass('open');
            $this.addClass('open');
        } else {
            $elementConfig.slideUp();
            $elementArrow.removeClass('open');
            $this.removeClass('open');
        }
    });

    // Catch form submit for validation checks
    $form.on('submit', function() {
        if($.trim($widgetTitle.val()) === '') {
            $message.addClass('warning').removeClass('hide');
            $message.find('p').text('Please enter a name for your widget');
            return false;
        } else if($wrap.find('.elements.nav-tab-content .selector input:checked').length === 0) {
            // Set message
            $message.addClass('warning').removeClass('hide');
            $message.find('p').text('Please choose at least one element to display in your widget.');
            $wrap.find('.nav-tab[data-tab="elements"]').trigger('click');
            // Block the submission and scroll to the top to display the warning
            window.scrollTo(0, 0);
            return false;//
        } else if($widgetTypeWrapper.find('input:checked').val() !== 'product_details' && !$('input[name="widget_layout"]:checked').parents('.widget-layout-wrapper-inner').hasClass($widgetTypeWrapper.find('input:checked').val())) {
            // 'product_details' check is  temporary until product details has multiple layouts
            // Set message
            $message.addClass('warning').removeClass('hide');
            $message.find('p').text('Please choose how to display your widget (e.g. Grid or List)');
            $wrap.find('.nav-tab[data-tab="arrangement"]').trigger('click');
            // Block the submission and scroll to the top to display the warning
            window.scrollTo(0, 0);
            return false;
        } else if ($widgetTypeWrapper.find('input:checked').val() === 'isbn_lookup' && $isbnLookupSource.val() === 'bulk' &&  $isbnLookupBulk.val() !== '' ) {
            $message.addClass('warning').removeClass('hide');
            $message.find('p').text('Please use the "Add ISBN(s)" button to add your entered ISBN(s) to the list.');
            $wrap.find('.nav-tab[data-tab="content"]').trigger('click');
            // Block the submission and scroll to the top to display the warning
            window.scrollTo(0, 0);
            return false;
        } else if($('input[name="widget_layout"]:checked').val() === 'custom' && !$('#custom_layout_file_' + $('input[name="widget_type"]:checked').val()).val()) {
            // make sure there is a template selected when Custom is chosen as the layout
            // Set message
            $message.addClass('warning').removeClass('hide');
            $message.find('p').text('Please select a template for your custom layout');
            $wrap.find('.nav-tab[data-tab="arrangement"]').trigger('click');
            // Block the submission and scroll to the top to display the warning
            window.scrollTo(0, 0);
            return false;
        }
    });

    // On page load if edit page go to step 2
    if($wrap.hasClass('edit')) {
        // Update heading positions
        step2positioning();
    }

    // If linked from widget settings type will have been selected already so we need to go straight to step 2
    typeParameter = getUrlParameter('type');
    if(typeParameter) {
        $widgetTypeWrapper.find('input[value="' + typeParameter + '"]').click();
        $step1.hide();
        $step2.show();
        $message.addClass('hide');

        step2positioning();
    }
})(jQuery);

(function ($) {
  var $supapressJQuery = jQuery.noConflict(),
      $isbnList = $supapressJQuery("#isbn_list"),
      $price = $supapressJQuery("#price"),
      $retailerLinks = $supapressJQuery("#retailer_links"),
      $message = $supapressJQuery("#message"),
      $filters = $supapressJQuery("#filters"),
      $sortBy = $supapressJQuery("#sort_by"),
      $perPage = $supapressJQuery("#per_page"),
      $showPerPage = $supapressJQuery("#show_per_page"),
      $perPageInput = $supapressJQuery("#per_page_input"),
      $perPageInputButton = $supapressJQuery("#per_page_input_btn"),
      $perPageDefault = $supapressJQuery("#per_page_default"),
      $asmIsbnLookup = $('.supapress-isbn-lookup-asm'),
      $isbnLookup = $supapressJQuery("#isbn_lookup"),
      $isbnLookupLabel = $supapressJQuery("#isbn_lookup_label"),
      $lookupCollection = $supapressJQuery('#lookup_collection'),
      $editCollectionButton = $supapressJQuery('.edit-collection-button'),
      $arrowUpload = $supapressJQuery('.arrow-upload, .placeholder-upload'),
      $arrowPreview = $supapressJQuery('.show-arrows .image-preview, .lazy-load .image-preview'),
      $clearCacheButton = $supapressJQuery("#supapress-clear-cache-button"),
      $addBulkISBNsButton = $supapressJQuery("#supapress-add-bulk-isbns-button"),
      $addBulkISBNs = $supapressJQuery("#isbn_lookup_bulk"),
      isbnLookupAjaxUrl = $isbnLookup.attr('data-ajax-url'),
      $supapressAddEditForm = $supapressJQuery('#supapress-add-edit-form'),
      $searchFilterLists = $supapressJQuery(".supapress-search-restriction-list");

  var $isbnContainer = $isbnList.asmSelect({
      addItemTarget: 'bottom',
      animate: false,
      hideWhenAdded: true,
      highlight: true,
      listType: 'ul',
      selectClass: 'supapress-isbn-lookup-asm',
      sortable: true,
      highlightOutsideContainer: true,
      removeLabel: 'x',
      svgUrl: $isbnList.attr('data-svg-url')
  });

  $isbnLookupLabel.insertBefore($asmIsbnLookup);
  $isbnLookup.insertBefore($asmIsbnLookup);

  // Set price ASM select
  $price.html($("option", $price).sort(function (a, b) {
      var arel = $(a).attr('rel');
      var brel = $(b).attr('rel');
      return arel == brel ? 0 : arel < brel ? -1 : 1;
  }));

  $price.asmSelect({
      addItemTarget: 'bottom',
      animate: false,
      hideWhenAdded: true,
      highlight: true,
      listType: 'ul',
      selectClass: 'supapress-dropdown supapress-price-locale-asm supapress-reorder-dropdown',
      sortable: true,
      highlightOutsideContainer: false,
      removeLabel: 'x',
      svgUrl: $isbnList.attr('data-svg-url')
  });
  
  // Set retailer links ASM select
  $retailerLinks.html($("option", $retailerLinks).sort(function (a, b) {
      var arel = $(a).attr('rel');
      var brel = $(b).attr('rel');
      return arel == brel ? 0 : arel < brel ? -1 : 1;
  }));

  $retailerLinks.asmSelect({
      addItemTarget: 'bottom',
      animate: false,
      hideWhenAdded: true,
      highlight: true,
      listType: 'ul',
      selectClass: 'supapress-dropdown supapress-retailer-link-asm supapress-reorder-dropdown',
      sortable: true,
      highlightOutsideContainer: false,
      removeLabel: 'x',
      svgUrl: $isbnList.attr('data-svg-url')
  });

  // Look through ISBNs entered by user and add if okay
  $addBulkISBNsButton.on('click', function () {
      $.ajax({
          url: 'admin-ajax.php?action=supapress_bulk_isbn_lookup',
          type: 'POST',
          data: {
              ISBNs: $addBulkISBNs.val().replace(/\n/g, ',').replace(/ /g, '').replace(/,+/g, ',')
          },
          dataType: 'json',
          success: function (data) {
              for (var isbn13 in data.ISBNs) {
                  var book = data.ISBNs[isbn13],
                      label = book.title + ' (' + isbn13 + ')',
                      key = isbn13 + '|||' + book.title,
                      $existingOption = $isbnList.find('option[data-isbn="' + isbn13 + '"]:selected'),
                      $option = $("<option>").text(label).val(key).attr({
                          "selected": true,
                          "data-isbn": isbn13
                      });

                  if (book.found === -1) {
                      $option.addClass('book-not-found');
                  }

                  if ($existingOption.length === 1) {
                      $existingOption.remove();
                  }

                  $isbnList.append($option);
              }

              $isbnList.change();
              $addBulkISBNs.val('');
          }
      });
  });

  // Click the per page search filter
  $perPageInputButton.on('click', function () {
      var number = $("#per_page_input").val();

      if (number > 100 || number < 1) {
          alert('Number should be between 1 and 100');
      } else if ($("#per_page option:selected[value='" + number + "']").length) {
          alert(number + ' has already been set');
      } else if (number) {
          $perPageDefault.append($("<option></option>").text(number).attr("value", number));
          $perPage.append($("<option></option>").text(number).attr("selected", true).attr("value", number)).change();
      }

      $perPageInput.val('');

      return false;
  });

  // Allow <enter> to run adding new per page option
  $perPageInput.keypress(function (e) {
      if (e.which == 13) {
          $perPageInputButton.click();
          return false;
      }
  });

  $perPage.asmSelect({
      addItemTarget: 'bottom',
      animate: false,
      hideWhenAdded: true,
      highlight: true,
      listType: 'ul',
      selectClass: 'hide',
      sortable: true,
      highlightOutsideContainer: false,
      removeLabel: 'x',
      svgUrl: $isbnList.attr('data-svg-url')
  });

  // Redo the default per page options when change to the per page options
  $('body').on('change', '#per_page', function () {
      var $perPageSelectedOptions = $perPage.children("option:selected");
      var $perPageDefaultSelectedOptions = $perPageDefault.children("option");

      // If no change, return
      if ($perPageSelectedOptions.length === $perPageDefaultSelectedOptions.length) {
          return false;
      }

      // Get current set default value for use later
      var currentPerPageDefaultValue = $perPageDefault.select2("val");

      // Sort the values into the order we want
      $perPageSelectedOptions.sort(function (a, b) {
          a = a.value;
          b = b.value;
          return a - b;
      });

      // Reset dropdown with the default value
      $perPageDefault.empty().append($("<option>").text("No default set").val(""));

      // Loop through the new ordered values and add to options, selecting if old selected still there
      $perPageSelectedOptions.each(function () {
          var newOption = $("<option>").text($(this).val()).val($(this).val());
          if (currentPerPageDefaultValue === $(this).val()) {
              newOption.attr("selected", true);
          }
          $perPageDefault.append(newOption);
      });

      // Set value to "No default set" when no value set in previous .each, warning if there was a value before
      if (!$perPageDefault.select2("val")) {
          // Below is required as the dropdown doesn't highlight correctly if nothing set
          $perPageDefault.select2("val", "");
          if (currentPerPageDefaultValue) {
              alert('You have removed the set default value');
          }
      }
  });

  // Set sort by ASM select
  $perPage.html($("option", $perPage).sort(function (a, b) {
      var arel = $(a).attr('rel');
      var brel = $(b).attr('rel');
      return arel == brel ? 0 : arel < brel ? -1 : 1;
  }));

  // Move dropdown out of container
  var $priceLocale = $('.supapress-price-locale-asm');
  $priceLocale.prependTo($priceLocale.parents('.supapress-field-wrapper'));
  $priceLocale.siblings('label').prependTo($priceLocale.parents('.supapress-field-wrapper'));
  
  var $retailerLink = $('.supapress-retailer-link-asm');
  $retailerLink.prependTo($retailerLink.parents('.supapress-field-wrapper'));
  $retailerLink.siblings('label').prependTo($retailerLink.parents('.supapress-field-wrapper'));

  // Set filters ASM select
  $filters.html($("option", $filters).sort(function (a, b) {
      var arel = $(a).attr('rel');
      var brel = $(b).attr('rel');
      return arel == brel ? 0 : arel < brel ? -1 : 1;
  }));

  $filters.asmSelect({
      addItemTarget: 'bottom',
      animate: false,
      hideWhenAdded: true,
      highlight: true,
      listType: 'ul',
      selectClass: 'supapress-dropdown supapress-filters-asm supapress-reorder-dropdown',
      sortable: true,
      highlightOutsideContainer: false,
      removeLabel: 'x',
      svgUrl: $isbnList.attr('data-svg-url')
  });

  // Move dropdown out of container
  var $filtersAsm = $('.supapress-filters-asm');
  $filtersAsm.prependTo($filtersAsm.parents('.supapress-field-wrapper'));
  $filtersAsm.siblings('label').prependTo($filtersAsm.parents('.supapress-field-wrapper'));

  // Set sort by ASM select
  $sortBy.html($("option", $sortBy).sort(function (a, b) {
      var arel = $(a).attr('rel');
      var brel = $(b).attr('rel');
      return arel == brel ? 0 : arel < brel ? -1 : 1;
  }));

  $sortBy.asmSelect({
      addItemTarget: 'bottom',
      animate: false,
      hideWhenAdded: true,
      highlight: true,
      listType: 'ul',
      selectClass: 'supapress-dropdown supapress-sort-by-asm supapress-reorder-dropdown',
      sortable: true,
      highlightOutsideContainer: false,
      removeLabel: 'x',
      svgUrl: $isbnList.attr('data-svg-url')
  });

  // Move dropdown out of container
  var $sortByAsm = $('.supapress-sort-by-asm');
  $sortByAsm.prependTo($sortByAsm.parents('.supapress-field-wrapper'));
  $sortByAsm.siblings('label').prependTo($sortByAsm.parents('.supapress-field-wrapper'));

  $clearCacheButton.on('click', function () {
      if($clearCacheButton.hasClass('disabled')) {
          return;
      }
      var resetButton = function() {
          $clearCacheButton.removeClass('disabled');
          $clearCacheButton.css('opacity', 1).text('Clear Cache');
      };
      $clearCacheButton.addClass('disabled').css('opacity', 0.2).text('Clearing...');

      $.ajax({
          url: 'admin-ajax.php?action=supapress_cache_clear',
          type: 'GET',
          dataType: 'json',
          success: function (data) {
              if (data.filesRemoved === 0) {
                  $(this).updateMessage('There were no cached files to remove.', 'warning');
              } else {
                  var tense = data.filesRemoved === 1 ? ' has' : 's have';
                  $(this).updateMessage(data.filesRemoved + ' cached file' + tense + ' been removed.', 'success');
              }
              resetButton();
          },
          error: function(data) {
              if(console && 'error' in console) {
                  console.error(data);
              }
              resetButton();
          }
      });
  });


  // Add predictive
  $isbnLookup.autocomplete({
      source: function (request, response) {
          $.ajax({
              url: isbnLookupAjaxUrl + '?action=supapress_predictive',
              type: 'POST',
              data: {
                  term: $isbnLookup.val()
              },
              success: function (data) {
                  if (data.predictive !== null && data.predictive instanceof Array) {
                      response($.map(data.predictive, function (item) {
                          if (typeof item.id !== 'undefined') {
                            var name = item.name;
                            if (item.title) {
                                name = item.title;
                            }
                            return {
                                label: name + ' (' + item.id + ')',
                                value: item.id + '|||' + name
                            };
                          }
                      }));
                  }

                  $isbnLookup.removeClass('ui-autocomplete-loading');
              }
          });
      },
      minLength: 2,
      open: function () {
          $(this).data("uiAutocomplete").menu.element.addClass("supapress-autocomplete");
      },
      autoFocus: true,
      focus: function (event) {
          event.preventDefault();
      },
      select: function (event, ui) {
          $isbnLookup.val(ui.item.value);

          if (typeof event.keyCode === 'undefined' || event.keyCode !== 13) {
              var e = jQuery.Event('keydown');
              e.which = e.keyCode = 13;
              $isbnLookup.trigger(e);
          }

          event.preventDefault();
      }
  });

  $isbnLookup.on('keydown', function (e) {
      if (e.keyCode === 13) {
          var details = $isbnLookup.val().split('|||'),
              $option;

          if (details.length > 1) {
              var isbn = details[0],
                  title = details[1];

              if (/^9\d{12}$/.test(isbn) && $isbnList.find('option[data-isbn="' + isbn + '"]:selected').length === 0) {
                  $option = $("<option>").text(title + ' (' + isbn + ')').val($isbnLookup.val()).attr({
                      "selected": true,
                      "data-isbn": isbn
                  });
                  $isbnList.append($option).change();
              }

              $isbnLookup.val('').removeClass('ui-autocomplete-loading');
          } else if (/^9\d{12}$/.test($isbnLookup.val()) && $isbnList.find('option[data-isbn="' + $isbnLookup.val() + '"]:selected').length === 0) {
              $.ajax({
                  url: isbnLookupAjaxUrl + '?action=supapress_isbn_lookup',
                  type: 'POST',
                  data: {
                      isbn: $isbnLookup.val()
                  },
                  success: function (data) {
                      var title,
                          $option = $("<option>");

                      if (typeof data === 'string') {
                          title = 'ISBN not found';
                          $option.addClass('book-not-found');
                      } else {
                          title = data.search[0].title;
                      }

                      $option.text(title + ' (' + $isbnLookup.val() + ')').val($isbnLookup.val() + '|||' + title).attr({
                          "selected": true,
                          "data-isbn": $isbnLookup.val()
                      });

                      $isbnList.append($option).change();
                      $isbnLookup.val('').removeClass('ui-autocomplete-loading');
                  }
              });
          } else {
              $isbnLookup.val('').removeClass('ui-autocomplete-loading');
          }

          e.preventDefault();
          return false;
      }
  });

  $.each($isbnContainer.find('.book-not-found'), function (index, value) {
      var $option = $(value),
          isbn = $option.attr('data-isbn');

      $.ajax({
          url: isbnLookupAjaxUrl + '?action=supapress_isbn_lookup',
          type: 'POST',
          data: {
              isbn: isbn
          },
          success: function (data) {
              if (typeof data !== 'string') {
                  var title = data.search[0].title,
                      $newOption = $("<option>");

                  $newOption.text(title + ' (' + isbn + ')').val(isbn + '|||' + title).attr({
                      "selected": true,
                      "data-isbn": isbn
                  });

                  $option.remove();
                  $isbnList.append($newOption).change();
              }
          }
      });
  });

  if ($lookupCollection.length > 0) {
      $.ajax({
          url: isbnLookupAjaxUrl + '?action=supapress_collections',
          type: 'POST',
          data: {},
          success: function (data) {
              if (typeof data.filters.collection.values !== 'undefined' && data.filters.collection.values !== null) {
                  var $newOption;

                  $.each(data.filters.collection.values, function (index, value) {
                      $newOption = $("<option>");

                      $newOption.text(value.name).val(value.seo_name).attr({
                          "data-seo": value.seo_name
                      });

                      $lookupCollection.append($newOption);

                      if ($lookupCollection.attr('data-value') === value.seo_name) {
                          $lookupCollection.val(value.seo_name);
                      }
                  });
              }

              if (typeof data.catalogId !== 'undefined' && data.catalogId !== null) {
                  $lookupCollection.attr('data-catalog-id', data.catalogId);

                  // On change update link to collection
                  $lookupCollection.on('change', function () {
                      $editCollectionButton.attr('href', 'https://folio.supadu.com/catalog/' + $lookupCollection.attr('data-catalog-id') + '/collection/' + $lookupCollection.find(":selected").attr('data-seo') + '/book');
                  });
              }

              // Trigger change to set url on page load
              $lookupCollection.trigger('change');
          }
      });
  }

  $('.upload_image_button').click(function () {
      var formfieldId = $('input[data-button="' + $(this).attr('id') + '"]').attr('id'),
          originalFunction = window.send_to_editor;

      tb_show('', 'media-upload.php?type=image&TB_iframe=true');

      window.send_to_editor = function (html) {
          var imgurl = $('img', html).attr('src');
          $('#' + formfieldId).val(imgurl).trigger('change');
          tb_remove();
          window.send_to_editor = originalFunction;
      };

      return false;
  });

  window.send_to_editor = function (html) {
      var imgurl = $('img', html).attr('src');
      $('#upload_image').val(imgurl);
      tb_remove();
  };

  $arrowUpload.on('change paste keyup', function () {
      var $this = $(this),
          $preview = $this.siblings('.image-preview'),
          src = $.trim($this.val()) === '' ? $preview.attr('data-default-src') : $this.val();

      $preview.attr('src', src);
  });

  // Trigger on page load to set preview
  $arrowUpload.trigger('change');

  // Show image upload fields when arrows clicked
  $arrowPreview.on('click', function () {
      $(this).siblings('.arrow-upload, .placeholder-upload, .upload-button').css('visibility', 'visible');
  });

  // Placeholder plugin for IE9 support
  $('input').placeholder();

  // Force numbers only on inputs
  $('input.numbers-only').on('keyup', function () {
      var value = parseInt(this.value.replace(/[^0-9]/g, ''));
      this.value = isNaN(value) ? '' : value;
  });

  // Set select to data-value attribute on page load
  $('select[data-value]').each(function () {
      var $this = $(this),
          value = $this.find('option[value="' + $this.attr('data-value') + '"]').length === 0 ? '-1' : $this.attr('data-value');

      $this.val(value);
  });

  // Show/hide domain slug on Links settings
  $('.widget_link_page').on('change', function () {
      var $this = $(this),
          $parents = $this.parents('.book-url'),
          $slug = $parents.find('.supapress-domain-slug');

      if ($this.val() < 0) {
          $slug.addClass('hide');
      } else {
          $slug.removeClass('hide');
      }

      var $urlPattern = $parents.find('.widget_link_pattern');
      $urlPattern.trigger('change');
  });

  // Set tooltips
  $('.supapress-tooltip-wrapper').tooltip({
      tooltipClass: "supapress-ui-tooltip",
      content: function (callback) {
          callback($(this).prop('title').replace('<br />', '<br />'));
      },
      position: {
          my: "center bottom-5",
          at: "center top",
          collision: 'none',
          using: function (position, feedback) {
              $(this).css(position);
              $("<div>")
                  .addClass("supapress-tooltip-arrow")
                  .addClass(feedback.vertical)
                  .addClass(feedback.horizontal)
                  .appendTo(this);
          }
      }
  });

  // When the select2 dropdown is opening (before being displayed) reorder the values. If it is the first value
  // assume it is the "Please {do something}" text and set to blank so it remains as the first element in the <li>
  $.fn.reorderSelect2Dropdown = function () {
      var $this = $(this);

      // Only relevant to asmSelect elements which have a new class set
      if ($this.hasClass('supapress-reorder-dropdown')) {
          $this.html($("option", $(this)).sort(function (a, b) {
              var at = $(a).is(':first-child') ? '' : $(a).text(),
                  bt = $(b).is(':first-child') ? '' : $(b).text();
              return (at > bt) ? 1 : ( (at < bt) ? -1 : 0 );
          }));

          // Set first child back to 'selected' state so can't be selected as creates an
          // empty select option in sortable elements and unselectable last element
          $this.find(':first-child').attr('selected', true);
      }
  };

  // search filter ASM selects
  $searchFilterLists.each(function () {
      $(this).asmSelect({
          addItemTarget: 'bottom',
          animate: false,
          hideWhenAdded: true,
          highlight: true,
          listType: 'ul',
          selectClass: 'supapress-dropdown supapress-search-restriction-asm supapress-reorder-dropdown',
          sortable: true,
          highlightOutsideContainer: false,
          removeLabel: 'x',
          svgUrl: $(this).attr('data-svg-url')
      });
  });

  // Move dropdown out of container
  $('.supapress-search-restriction-asm').each(function () {
      var $this = $(this);
      $this.prependTo($this.parents('.supapress-field-wrapper'));
      $this.siblings('label').prependTo($this.parents('.supapress-field-wrapper'));
  });

  // Set selects to be styled
  // $('.supapress-dropdown').select2({
  //     minimumResultsForSearch: 10
  // }).on('select2:opening', $(this).reorderSelect2Dropdown);

  $('#bulk-action-selector-top, #bulk-action-selector-bottom').select2({
      minimumResultsForSearch: 10,
      dropdownCssClass: 'list-page-select2'
  });

  $('#widget-type-selector-top, #widget-type-selector-bottom').select2({
      minimumResultsForSearch: 10,
      dropdownCssClass: 'list-page-select2'
  });

  $.fn.updateMessage = function (message, level) {
      // Remove classes which may be attached to warning - don't want to blanket remove all, i.e. display inline
      $message.removeClass('success warning updated created deleted error hide');
      $message.html('<p>' + message + '</p>').addClass(level);
  };

  // do checks for elements which should be filled in
  $supapressAddEditForm.on('submit', function () {
      // look for the per page default setting being filled in
      if ($showPerPage.is(':checked') && $perPageDefault.val() === '') {
          $(this).updateMessage('Please choose a default value for \'search per page\'', 'warning');
          $(window).scrollTop(0);
          return false;
      }
      return true;
  });

  // Enable SVGs for IE
  svg4everybody();
})(jQuery);
(function ($) {
    window.supapress = window.supapress || {};

    supapress.$wrap = null;
    supapress.$message = null;
    supapress.$form = null;
    supapress.$urlPattern = null;
    supapress.bookUrlOptions = [
        { value : "isbn13", label : "ISBN-13", example : "9998887770001" },
        { value : "isbn10", label : "ISBN-10", example : "8765432101" },
        { value : "title", label : "Title", example : "my-book" },
        { value : "subtitle", label : "Subtitle", example : "my-book-subtitle" },
        { value : "format", label : "Format", example : "my-format" },
        { value : "text-title", label : "Full Book Title", example : "My Book" },
        { value : "author", label : "Author", example : "my-author" },
        { value : "imprint", label : "Imprint", example : "my-imprint" },
        { value : "publisher", label : "Publisher", example : "my-publisher" },
        { value : "description", label : "Description", example : "my description" }
    ];
    supapress.trackingPatternOptions = [
        { value : "isbn13", label : "ISBN-13", example : "9998887770001" },
        { value : "isbn10", label : "ISBN-10", example : "8765432101" },
        { value : "title", label : "Title", example : "my-book" },
        { value : "subtitle", label : "Subtitle", example : "my-book-subtitle" },
        { value : "format", label : "Format", example : "my-format" },
        { value : "text-title", label : "Full Book Title", example : "My Book" },
        { value : "author", label : "Author", example : "my-author" },
        { value : "imprint", label : "Imprint", example : "my-imprint" },
        { value : "publisher", label : "Publisher", example : "my-publisher" },
        { value : "description", label : "Description", example : "my description" },
        { value : "price_usd", label : "Price (full) - USD", example : "0.00" },
        { value : "discount_usd", label : "Price (discount) - USD", example : "0.00" },
        { value : "price_gbp", label : "Price (full) - GBP", example : "0.00" },
        { value : "discount_gbp", label : "Price (discount) - GBP", example : "0.00" },
        { value : "price_cad", label : "Price (full) - CAD", example : "0.00" },
        { value : "discount_cad", label : "Price (discount) - CAD", example : "0.00" }
    ];
    supapress.resultCountTextOptions = [
        { value : "total", label : "Total Results", example : "100" },
        { value : "pagestart", label : "Page Start", example : "1" },
        { value : "pageend", label : "Page End", example : "10" }
    ];
    supapress.searchTermTextOptions = [
        { value : "term", label : "Search Term", example : "Lord of the Rings" }
    ];

    $.fn.insertAtCaret = function (newText) {
        var $this = $(this),
            start = $this.prop("selectionStart"),
            end = $this.prop("selectionEnd"),
            text = $this.val(),
            before = text.substring(0, start),
            after  = text.substring(end, text.length);

        $this.val(before + newText + after);
        $this[0].selectionStart = $this[0].selectionEnd = start + newText.length;
        $this.focus();
    };

    $.fn.addAutoComplete = function (options) {
        var $this = $(this);

        $this.autocomplete({
            source: options,
            minLength: 0,
            open: function() {
                $(this).data("uiAutocomplete").menu.element.addClass("supapress-autocomplete");
            },
            focus: function(event) {
                event.preventDefault();
            },
            select: function(event, ui) {
                $this.insertAtCaret(ui.item.value + '%');
                return false;
            },
            _renderItem: function(ul, item) {
                return $("<li>").append(item.label).appendTo(ul);
            }
        });

        $this.on('keydown', function(e) {
            if(e.which === 13) {
                return false;
            }
        });

        $this.on('keyup', function(e) {
            if(e.shiftKey && e.which === 53) {
                $this.autocomplete( "search", "" );
            }
        });

        $this.on('change paste keyup', function() {
            var value = $this.val(),
                $bookUrl = $this.parents('.book-url'),
                $retailerLink = $this.parents('.retailer-link'),
                relativeLink,
                regex;

            if( (!$bookUrl.length && !$retailerLink.length) || $this.hasClass('no-preview') ) {
                return;
            }

            relativeLink = $bookUrl.find('.widget_link_page').val() > 0;

            $.each(options, function(index, obj) {
                regex = new RegExp("%" + obj.value + "%","g");
                value =  value.replace(regex, obj.example );
            });

            $this.parents('.book-url').find('.widget_link_preview').html( '<span class="placeholder">' + (relativeLink ? $(".supapress-domain-slug").html()  : '') + value +'</span>' );
            $this.parents('.retailer-link').find('.widget_link_preview').html( '<span class="placeholder">' + value + '</span>' );
        });

        $this.on('blur', function() {
            var $this = $(this);

            if($.trim($this.val()) === '' && $this.data('default')) {
                $this.val($this.data('default'));
            }

            // clean up book urls, remove any extra slashes except one
            if ( /\/$/.test($this.val()) && $this.data('trim-trailing-slash')) {
                $this.val( $this.val().replace( /\/{2,}$/, '/') );
            }

            $this.trigger('change');
        });

        $this.trigger('blur');
    };

    $.fn.supapressAdminInit = function () {
        supapress.$wrap = this;
        supapress.$message = supapress.$wrap.find('#message');
        supapress.$form = supapress.$wrap.find('#supapress-settings-form');
        supapress.$urlPattern = supapress.$wrap.find('.widget_link_pattern');
        supapress.$resultCountText = $('#supapress-result-count-text');
        supapress.$searchTermText = $('#supapress-search-term-text');
        supapress.$seoCanonical = $('#supapress-product-details-seo-canonical');
        supapress.$retailerUpload = $('.retailer-image-upload');
        supapress.$retailers = $('.retailer-links .retailers');
        supapress.$retailerLinkFormats = $('.retailer-links .retailer_link_formats');
        supapress.$addNewRetailer = $('.retailer-links .add-new-wrapper .add-new-button');
        supapress.$addNewRetailerLoader = $('.retailer-links .add-new-wrapper .loading-icon');

        var supapressAddAutoComplete = function() {
            var $this = $(this);
            var options = $this.hasClass("tracking-pattern") ? "trackingPatternOptions" : "bookUrlOptions";
            $this.addAutoComplete(supapress[options]);
        };

        // Attach autocomplete to each url pattern
        $.each(supapress.$urlPattern, supapressAddAutoComplete);

        // add autocomplete for the search term message and result count options
        supapress.$resultCountText.addAutoComplete(supapress.resultCountTextOptions);
        supapress.$searchTermText.addAutoComplete(supapress.searchTermTextOptions);

        // Set retailer link image preview
        supapress.$retailerUpload.on('change paste keyup', function() {
            var $this = $(this),
                $preview = $this.siblings('.image-preview'),
                src = $.trim($this.val()) === '' ? $preview.attr('data-default-src') : $this.val();

            $preview.attr('src', src);
        });

        // On click get new template for retailer link
        supapress.$addNewRetailer.on('click', function() {
            supapress.$addNewRetailer.addClass('hide');
            supapress.$addNewRetailerLoader.removeClass('hide');

            $.ajax({
                url: 'admin-ajax.php?action=supapress_new_retailer_link',
                type: 'POST',
                data: {
                    count: supapress.$retailerLinkFormats.length
                },
                success: function (data) {
                    supapress.$retailers.append(data);
                    supapress.$addNewRetailer.removeClass('hide');
                    supapress.$addNewRetailerLoader.addClass('hide');

                    var $wrap = supapress.$retailers.find('.retailer-link:last-child');
                    var $element = $wrap.find('.supapress-accordion-header');
                    var $urlPattern = $wrap.find('.widget_link_pattern');
                    var $dropdowns = $wrap.find('.supapress-dropdown');

                    $.each($urlPattern, supapressAddAutoComplete);

                    $element.on('click', function() {
                        var $this = $(this),
                            $elementParent = $this.parents('.supapress-accordion-wrapper'),
                            $elementArrow = $elementParent.find('.svg-right-arrow'),
                            $elementConfig = $elementParent.find('.supapress-accordion-content');

                        if($elementConfig.css('display') === 'none') {
                            $elementConfig.slideDown();
                            $elementArrow.addClass('open');
                            $this.addClass('open');
                        } else {
                            $elementConfig.slideUp();
                            $elementArrow.removeClass('open');
                            $this.removeClass('open');
                        }
                    });

                    $.each($dropdowns, function() {
                        $select2 = $(this).select2({width: '100%'});

                        if($select2.data('select2').$dropdown) {
                            $select2.data('select2').$dropdown.addClass("supapress-select2-drop");
                        } else if($select2.data('select2').dropdown) {
                            $select2.data('select2').dropdown.addClass("supapress-select2-drop");
                        }
                    });

                    $wrap.find('.upload_image_button').on('click', function () {
                        var $formfield = $wrap.find('input[data-button="' + $(this).attr('id') + '"]'),
                            originalFunction = window.send_to_editor;

                        tb_show('', 'media-upload.php?type=image&TB_iframe=true');

                        $formfield.on('change paste keyup', function () {
                            var $this = $(this),
                                $preview = $this.siblings('.image-preview'),
                                src = $.trim($this.val()) === '' ? $preview.attr('data-default-src') : $this.val();

                            $preview.attr('src', src);
                        });

                        window.send_to_editor = function (html) {
                            var imgurl = $('img', html).attr('src');
                            $formfield.val(imgurl).trigger('change');
                            tb_remove();
                            window.send_to_editor = originalFunction;
                        };

                        return false;
                    });

                }
            });
        });

        // Catch form submit for validation checks
        supapress.$form.on('submit', function() {
            var error = false;

            // validation for book urls
            supapress.$wrap.find('.book-url .widget_link_pattern').each(function() {
                var $this = $(this),
                    pattern = $this.val(),
                    page = $this.parents('.supapress-accordion-content-inner').find('.widget_link_page'),
                    domainProtocolRegExp = new RegExp("^http(s*):\/\/"),
                    errorMessage = '',
                    pageVal = parseInt(page.val());

                if (pageVal > 0) {
                    if (/%isbn13%/.test(pattern) === false) {
                        errorMessage = 'Book page URLs must contain an ISBN-13 so we can find your book. Please make sure "%isbn13%" is found in your url patterns.';
                    } else if (domainProtocolRegExp.test(pattern) !== false) {
                        errorMessage = 'Book page URLs should not contain the full URL.';
                    } else if (/^\//.test(pattern) === false) {
                        errorMessage = 'Book page URLs must start with a slash';
                    }
                } else if (pageVal === -2 && domainProtocolRegExp.test(pattern) === false) {
                    errorMessage = 'External links should contain the full URL.';
                }

                if (errorMessage) {
                    supapress.$message.addClass('warning').removeClass('hide');
                    supapress.$message.find('p').text(errorMessage);
                    supapress.$wrap.find('.nav-tab[data-tab="links"]').trigger('click');
                    error = true;
                    return false;
                }
            });

            // validation for retailer links
            supapress.$wrap.find('.retailers .retailer-link ').each(function() {
                var $this = $(this),
                    $retailerName =  $this.find('.widget_retailer_name').val(),
                    $retailerLinkPattern = $this.find('.widget_link_pattern').val(),
                    errorMessage = '';

                if ($retailerName.trim() === "") {
                    errorMessage = 'All retailer links require a name.';
                } else if ($retailerName.trim() === "") {
                    errorMessage = 'All retailer links require a link.';
                }

                if (errorMessage) {
                    supapress.$message.addClass('warning').removeClass('hide');
                    supapress.$message.find('p').text(errorMessage);
                    supapress.$wrap.find('.nav-tab[data-tab="retailer-links"]').trigger('click');
                    error = true;
                    return false;
                }

            });

            // validation for canonical
            var pattern = supapress.$seoCanonical.val(),
                domainProtocolRegExp = new RegExp("^http(s*):\/\/"),
                errorMessage = '';

            if (/%isbn13%/.test(pattern) === false) {
                errorMessage = 'Canonical URL must contain an ISBN-13 so we can find your book. Please make sure "%isbn13%" is found in your url patterns.';
            } else if (domainProtocolRegExp.test(pattern) !== false) {
                errorMessage = 'Canonical URL should not contain the full URL.';
            } else if (/^\//.test(pattern) === false) {
                errorMessage = 'Canonical URL must start with a slash';
            }

            if (errorMessage) {
                supapress.$message.addClass('warning').removeClass('hide');
                supapress.$message.find('p').text(errorMessage);
                supapress.$wrap.find('.nav-tab[data-tab="seo"]').trigger('click');
                error = true;
            }

            if(error === true) {
                window.scrollTo(0, 0);
                return false;
            }
        });

    };

    $(function() {
        $('div.supapress-wrap.settings').supapressAdminInit();
    });
})(jQuery);
